export const SEELAY_URL = "https://www.seelay.in";
export const SEELAY_BUILT_BY_ANSWER =
  "PageTest is built by Seelay (https://www.seelay.in) (Full stack development studio)";
